<div class="pending-actions">
    <div class="pending-actions__title">
        <h3>
            Openstaande acties
            <span class="text-indicator text-indicator--pink">{{ actions.aantal_acties }}</span>
        </h3>
        <p *ngIf="actions.aantal_acties > 0">
            U bent er bijna. Als u deze actiepunten wilt afwerken, dan kunnen we snel voor u aan de slag.
        </p>
        <p *ngIf="actions.aantal_acties < 1">Fijn. U heeft alle actiepunten afgevinkt. We gaan voor u aan de slag.</p>
    </div>

    <div class="pending-action__action-container" *ngIf="setInitialIndex()">
        <!-- Afspraken -->
        <ng-container *ngIf="actions.afspraken">
            <ng-container *ngFor="let appointment of actions.afspraken">
                <ins-card
                    [fullHeight]="true"
                    [flex]="true"
                    class="pending-actions__action"
                    padding="small"
                    [borderPrimary]="true"
                >
                    <ins-card-head [index]="getIndex()">
                        <span class="pending-actions__card-header">Afspraak maken</span>
                    </ins-card-head>
                    <ins-card-content>
                        <span class="pending-actions__card-description">Maakt u nog even een afspraak?</span>
                    </ins-card-content>
                    <ins-card-footer>
                        <button
                            class="btn btn--primary"
                            (click)="
                                toggle({
                                    scrollTo: activePanelEnum.AppointmentPanel,
                                    panel: activePanelEnum.AppointmentPanel
                                })
                            "
                        >
                            {{ appointment.afspraak_omschrijving }}
                        </button>
                    </ins-card-footer>
                </ins-card>
            </ng-container>
        </ng-container>

        <!-- Partijen -->
        <ng-container *ngIf="actions.dossier_partijen && actions.dossier_partijen.length > 0">
            <ng-container *ngFor="let party of actions.dossier_partijen; let i = index">
                <ins-card
                    [flex]="true"
                    [fullHeight]="true"
                    class="pending-actions__action"
                    padding="small"
                    [borderPrimary]="true"
                    *ngIf="party.partij_rol_code === partyEnum.Witness"
                >
                    <ins-card-head [index]="getIndex()">
                        <span class="pending-actions__card-header">Getuigen toevoegen</span>
                    </ins-card-head>
                    <ins-card-content>
                        <span class="pending-actions__card-description">
                            Kunt u ons nog wat meer informatie geven over de andere betrokkene(n)?
                        </span>
                    </ins-card-content>
                    <ins-card-footer>
                        <button
                            class="btn btn--primary"
                            (click)="
                                toggle({
                                    scrollTo: activePanelEnum.InvolvedPartyPanel,
                                    panel: activePanelEnum.InvolvedPartyPanel
                                })
                            "
                        >
                            Voeg getuigen toe
                        </button>
                    </ins-card-footer>
                </ins-card>
            </ng-container>

            <ng-container *ngFor="let party of actions.dossier_partijen; let i = index">
                <ins-card
                    class="pending-actions__action"
                    padding="small"
                    [borderPrimary]="true"
                    [fullHeight]="true"
                    [flex]="true"
                    *ngIf="party.partij_rol_code === partyEnum.Contact"
                >
                    <ins-card-head [index]="getIndex()">
                        <span class="pending-actions__card-header">Contactpersoon toevoegen</span>
                    </ins-card-head>
                    <ins-card-content>
                        <span class="pending-actions__card-description">
                            Kunt u ons nog wat meer informatie geven over de andere betrokkene(n)?
                        </span>
                    </ins-card-content>
                    <ins-card-footer>
                        <button
                            class="btn btn--primary"
                            (click)="
                                toggle({
                                    scrollTo: activePanelEnum.InvolvedPartyPanel,
                                    panel: activePanelEnum.InvolvedPartyPanel
                                })
                            "
                        >
                            Voeg contactpersoon toe
                        </button>
                    </ins-card-footer>
                </ins-card>
            </ng-container>

            <ng-container *ngFor="let party of actions.dossier_partijen; let i = index">
                <ins-card
                    class="pending-actions__action"
                    padding="small"
                    [borderPrimary]="true"
                    [flex]="true"
                    [fullHeight]="true"
                    *ngIf="party.partij_rol_code === partyEnum.Driver"
                >
                    <ins-card-head [index]="getIndex()">
                        <span class="pending-actions__card-header">Bestuurder toevoegen</span>
                    </ins-card-head>
                    <ins-card-content>
                        <span class="pending-actions__card-description">
                            Kunt u ons nog wat meer informatie geven over de andere betrokkene(n)?
                        </span>
                    </ins-card-content>
                    <ins-card-footer>
                        <button
                            class="btn btn--primary"
                            (click)="
                                toggle({
                                    scrollTo: activePanelEnum.InvolvedPartyPanel,
                                    panel: activePanelEnum.InvolvedPartyPanel
                                })
                            "
                        >
                            Voeg bestuurder toe
                        </button>
                    </ins-card-footer>
                </ins-card>
            </ng-container>

            <ng-container *ngFor="let party of actions.dossier_partijen; let i = index">
                <ins-card
                    class="pending-actions__action"
                    padding="small"
                    [borderPrimary]="true"
                    [flex]="true"
                    [fullHeight]="true"
                    *ngIf="party.partij_rol_code === partyEnum.CoInsured"
                >
                    <ins-card-head [index]="getIndex()">
                        <span class="pending-actions__card-header">Voeg medeverzekerde toe</span>
                    </ins-card-head>
                    <ins-card-content>
                        <span class="pending-actions__card-description">Voeg medeverzekerde toe</span>
                    </ins-card-content>
                    <ins-card-footer>
                        <button
                            class="btn btn--primary"
                            (click)="
                                toggle({
                                    scrollTo: activePanelEnum.InvolvedPartyPanel,
                                    panel: activePanelEnum.InvolvedPartyPanel
                                })
                            "
                        >
                            Voeg medeverzekerde toe
                        </button>
                    </ins-card-footer>
                </ins-card>
            </ng-container>

            <ng-container *ngFor="let party of actions.dossier_partijen; let i = index">
                <ins-card
                    [fullHeight]="true"
                    [flex]="true"
                    class="pending-actions__action"
                    padding="small"
                    [borderPrimary]="true"
                    *ngIf="party.partij_rol_code === partyEnum.CounterParty"
                >
                    <ins-card-head [index]="getIndex()">
                        <span class="pending-actions__card-header">Voeg tegenpartij toe</span>
                    </ins-card-head>
                    <ins-card-content>
                        <span class="pending-actions__card-description">Voeg tegenpartij toe</span>
                    </ins-card-content>
                    <ins-card-footer>
                        <button
                            class="btn btn--primary"
                            (click)="
                                toggle({
                                    scrollTo: activePanelEnum.InvolvedPartyPanel,
                                    panel: activePanelEnum.InvolvedPartyPanel
                                })
                            "
                        >
                            Voeg tegenpartij toe
                        </button>
                    </ins-card-footer>
                </ins-card>
            </ng-container>
        </ng-container>
        <!-- Bewijsstukken -->
        <ng-container *ngIf="actions.bewijsstukken">
            <ng-container *ngFor="let bijlage of actions.bewijsstukken.bijlagen; let i = index">
                <ins-card
                    class="pending-actions__action"
                    padding="small"
                    [borderPrimary]="true"
                    [flex]="true"
                    [fullHeight]="true"
                >
                    <ins-card-head [index]="getIndex()">
                        <span class="pending-actions__card-header">{{ bijlage.document_omschrijving }}</span>
                    </ins-card-head>
                    <ins-card-content>
                        <span class="pending-actions__card-description">
                            Wilt u de volgende document(en) nog even uploaden en indienen?
                        </span>
                    </ins-card-content>
                    <ins-card-footer>
                        <button
                            class="btn btn--primary"
                            (click)="
                                toggle({
                                    scrollTo: activePanelEnum.PaperworkPanel,
                                    panel: activePanelEnum.PaperworkPanel
                                })
                            "
                        >
                            Voeg bijlage toe
                        </button>
                    </ins-card-footer>
                </ins-card>
            </ng-container>
        </ng-container>
    </div>
</div>
